import React from 'react';
import { faBell, faUmbrellaBeach, faShip, faFileInvoiceDollar, faShieldHalved, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const iconFor = (type = '') => {
  if (type.startsWith('leave')) return [faUmbrellaBeach, 'warn'];
  if (type.startsWith('delivery') || type.startsWith('ops_delivery')) return [faShip, 'brand'];
  if (type.includes('credit') || type.includes('kyc')) return [faShieldHalved, 'info'];
  if (type.includes('invoice') || type.includes('financial') || type.includes('note') || type.includes('accounting')) return [faFileInvoiceDollar, 'warn'];
  if (type.includes('template') || type.includes('document')) return [faFileLines, 'neutral'];
  return [faBell, 'neutral'];
};

const NeedsActionWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  return (
    <>
      {items.length === 0 && <WidgetEmpty>Nothing needs your action right now.</WidgetEmpty>}
      {items.map((n) => {
        const [icon, tone] = iconFor(n.notification_type);
        return (
          <WidgetRow
            key={n.id}
            icon={icon}
            tone={tone}
            title={n.title}
            subtitle={n.description || n.notification_type_display}
            right={(
              <>
                {n.priority === 'urgent' && <Pill tone="error">Urgent</Pill>}
                <Age>{n.age_label}</Age>
              </>
            )}
            onClick={() => goTo(n.action_url || data.url)}
          />
        );
      })}
      <WidgetFooter
        label={data.unread_total > 0 ? `View all ${data.unread_total} unread notifications` : 'Open notifications'}
        url={data.url}
      />
    </>
  );
};

export default NeedsActionWidget;
